// extracted by mini-css-extract-plugin
export default {"titleWrapper":"style_titleWrapper__r8+ay","gogButton":"style_gogButton__vdFiJ","tabItem":"style_tabItem__82Jbj","tabWrapper":"style_tabWrapper__-QBZf"};